// extracted by mini-css-extract-plugin
export default {"activityItemButton":"AddEventButton__activityItemButton___Nfsr8","activityIcon":"AddEventButton__activityIcon____djv6","label":"AddEventButton__label___uUoAo"};